import { GOOGLE_RECAPTCHA_SITE_KEY } from '@reverbdotcom/env';
import window from './window_wrapper';

export async function generateRecaptchaToken(action) {
  const recaptchaToken = await window.grecaptcha.enterprise.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action });

  return recaptchaToken;
}
